module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('em', [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_c('em', [_vm._v("John F. X. Burton, S.J."), _c('br'), _vm._v("1921–1997")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_c('em', [_vm._v("Thurston N. Davis, S.J."), _c('br'), _vm._v("1913–1986")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_c('em', [_vm._v("Joseph R. Frese, S.J."), _c('br'), _vm._v("1914–2002")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_c('em', [_vm._v("David S. Toolan, S.J."), _c('br'), _vm._v("1935–2002")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cb6c9d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 66
// module chunks = 0